/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  MyCertifiedPlantId,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetCertifiedPlantIdByDeviceIdInput {
  deviceId: string;
}
const build = (_query: DocumentNode, input: GetCertifiedPlantIdByDeviceIdInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getCertifiedPlantIdByDeviceId(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' }
    ){
      ...mycertifiedplantid
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetCertifiedPlantIdByDeviceIdQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment mycertifiedplantid on MyCertifiedPlantId { ... }
   */
  async execute(_query: DocumentNode, input: GetCertifiedPlantIdByDeviceIdInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getCertifiedPlantIdByDeviceId: Partial<MyCertifiedPlantId> }>({ query: build(_query, input), fetchPolicy });
  }
}
